"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class PubOrg extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'pubOrg';
        this._orgCurrency = initParams.org_currency;
        this._name = initParams.name;
        this._websiteUrl = initParams.website_url;
        this._cloneFromId = initParams.clone_from_id;
        this._cloneToId = initParams.clone_to_id;
        this._contactEmail = initParams.contact_email;
        this._contactPhone = initParams.contact_phone;
        this._address = initParams.address;
        this._mfaEnforced = initParams.mfa_enforced;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._emailAddress = initParams.email_address;
        this._free = initParams.free;
        this._tour = initParams.tour;
        this._industry = initParams.industry;
        this._goals = (0, util_1.camelArray)(initParams.goals);
    }
    set orgCurrency(value) {
        console.error('Do not set objects this way');
    }
    get orgCurrency() {
        return this._orgCurrency;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set websiteUrl(value) {
        console.error('Do not set objects this way');
    }
    get websiteUrl() {
        return this._websiteUrl;
    }
    set cloneFromId(value) {
        console.error('Do not set objects this way');
    }
    get cloneFromId() {
        return this._cloneFromId;
    }
    set cloneToId(value) {
        console.error('Do not set objects this way');
    }
    get cloneToId() {
        return this._cloneToId;
    }
    set contactEmail(value) {
        console.error('Do not set objects this way');
    }
    get contactEmail() {
        return this._contactEmail;
    }
    set contactPhone(value) {
        console.error('Do not set objects this way');
    }
    get contactPhone() {
        return this._contactPhone;
    }
    set address(value) {
        console.error('Do not set objects this way');
    }
    get address() {
        return this._address;
    }
    set mfaEnforced(value) {
        console.error('Do not set objects this way');
    }
    get mfaEnforced() {
        return this._mfaEnforced;
    }
    set orgEmailAddress(value) {
        console.error('Do not set objects this way');
    }
    get orgEmailAddress() {
        return this._orgEmailAddress;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set free(value) {
        console.error('Do not set objects this way');
    }
    get free() {
        return this._free;
    }
    set tour(value) {
        console.error('Do not set objects this way');
    }
    get tour() {
        return this._tour;
    }
    set industry(value) {
        console.error('Do not set objects this way');
    }
    get industry() {
        return this._industry;
    }
    set goals(value) {
        console.error('Do not set objects this way');
    }
    get goals() {
        return this._goals;
    }
}
exports.default = PubOrg;
//# sourceMappingURL=pubOrg.js.map